var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-card',{staticClass:"asset-planning-card",attrs:{"shadow":"never"}},[_c('div',{staticClass:"header-row",attrs:{"slot":"header"},slot:"header"},[_c('div',{staticClass:"title"},[_c('span',{staticStyle:{"margin-right":"10px"}},[_vm._v("资产规划类型")])]),_c('div',{staticStyle:{"color":"#409eff","font-size":"14px","cursor":"pointer"},on:{"click":() => {
					this.$router.push('/pages/asset/assetPlan');
				}}},[_vm._v(" 更多 ")])]),_c('div',{staticClass:"content-row"},[_c('PieChart',{attrs:{"categories":_vm.planningTypes,"option":{
				series: [
					{
						radius: ['65%', '85%'],
					},
				],
			}}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }